export const contentSpacing = '300';

export enum RoutingRulesTableDataTestIds {
    OptionViewDetail = 'rr-table-view-detail',
    OptionEdit = 'rr-table-edit',
    OptionDelete = 'rr-table-delete',
}

export const routingRulesTableFormId = 'routingRulesTableForm';
